import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "product-cards"
};
var _hoisted_2 = {
  key: 0,
  class: "product-cards-title"
};
var _hoisted_3 = {
  class: "banks"
};
var _hoisted_4 = ["href"];
var _hoisted_5 = ["src", "alt"];
var _hoisted_6 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.title ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */)) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getCompanies, function (company) {
    return _openBlock(), _createElementBlock("div", {
      class: "bank",
      key: company.uniqueShortcut
    }, [_createElementVNode("a", {
      href: $options.linkCompany(company),
      target: "_blank"
    }, [$props.locale === 'cs-CZ' ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $options.logoSrc(company),
      alt: company.name,
      class: _normalizeClass(company.uniqueShortcut === 'CSOB' ? 'img-small' : '')
    }, null, 10 /* CLASS, PROPS */, _hoisted_5)) : (_openBlock(), _createElementBlock("img", {
      key: 1,
      src: "/Imgs/".concat(company.uniqueShortcut, ".svg"),
      alt: company.name,
      class: _normalizeClass(company.uniqueShortcut === 'SK_CSOB' || company.uniqueShortcut === 'SK_TB' ? 'sk-img' : 'sk-img-enlarged')
    }, null, 10 /* CLASS, PROPS */, _hoisted_6))], 8 /* PROPS */, _hoisted_4)]);
  }), 128 /* KEYED_FRAGMENT */))])]);
}